/**
 * src/components/Navbar.jsx
 * Logo circle currently shows "R" — replace with an <img> tag once you
 * have a real logo file (see the commented block below the circle).
 */
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../lib/cart";
import { AnnouncementBar } from "./AnnouncementBar";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About Us" },
  { to: "/shipping-returns", label: "Shipping & Returns" },
  { to: "/contact", label: "Contact" },
];

function CartIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M6 8h12l-1 12H7L6 8Z" strokeLinejoin="round" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" strokeLinecap="round" />
    </svg>
  );
}

export function Navbar() {
  const { itemCount } = useCart();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => (path === "/shop" ? location.pathname.startsWith("/shop") : location.pathname === path);

  return (
    <>
      <AnnouncementBar />
      <nav className="navbar">
        <Link to="/" className="navbar-brand" onClick={() => setMenuOpen(false)}>
{/*           <span className="navbar-avatar">R</span> */}
              <img src="/store-logo.jpeg" alt="Ritu Fashion Store" className="navbar-avatar-img" />
          <span className="navbar-brand-text">
            <span className="navbar-brand-name">Ritu Fashion</span>
            <span className="navbar-brand-sub">STORE</span>
          </span>
        </Link>

        <div className="navbar-links">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`navbar-link ${isActive(l.to) ? "active" : ""}`}>
              {l.label}
            </Link>
          ))}
        </div>

        <div className="navbar-actions">
          <Link to="/cart" className="cart-badge navbar-icon-btn" aria-label="Cart" onClick={() => setMenuOpen(false)}>
            <CartIcon />
            {itemCount > 0 && <span className="cart-badge-count">{itemCount}</span>}
          </Link>
          <button className="navbar-hamburger" aria-label="Menu" onClick={() => setMenuOpen((v) => !v)}>
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="navbar-mobile-menu">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`navbar-link ${isActive(l.to) ? "active" : ""}`} onClick={() => setMenuOpen(false)}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}